var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 247,
    viewBox: "0 0 256 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.766 42.413a68.673 68.673 0 00-34.755 9.53 68.992 68.992 0 00-25.202 25.84 37.662 37.662 0 00-16.485-3.827 37.694 37.694 0 00-24.42 9.071 37.944 37.944 0 00-12.768 22.774A52.055 52.055 0 009.92 125.033a52.34 52.34 0 00-8.712 28.918 52.3 52.3 0 0015.262 36.89 51.925 51.925 0 0036.78 15.264 51.973 51.973 0 006.524-.472h144.602c.759.055 1.52.092 2.281.11.725-.02 1.45-.057 2.174-.11h3.463v-.259c11.773-1.397 22.629-7.102 30.51-16.032 7.88-8.931 12.238-20.467 12.246-32.421v-.094a49.073 49.073 0 00-11.172-31.075c-7.193-8.734-17.18-14.666-28.243-16.777a69.22 69.22 0 00-21.048-47.233 68.728 68.728 0 00-47.822-19.33z",
    fill: "url(#icloud_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icloud_svg__paint0_linear",
    x1: 255.822,
    y1: 157.053,
    x2: 1.115,
    y2: 153.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E82F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93DCF7"
  })))));
}

export default SvgIcloud;